<template>
  <div class="table-box gift_record_container">
    <global-tag>
      <el-form label-width="120px" :model="searchObj" ref="searchObj">
        <el-row>
          <el-col :span="6">
            <el-form-item label="姓名：">
              <el-input
                clearable
                placeholder="请输入"
                v-model="searchObj.customerName"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="性别：">
              <el-select
                placeholder="请选择"
                v-model="searchObj.gender"
                clearable
                style="width: 100%"
              >
                <el-option label="男" value="0"></el-option>
                <el-option label="女" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="手机号码：">
              <el-input
                placeholder="请输入"
                v-model="searchObj.phone"
                clearable
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" :offset="1">
            <el-button
              type="primary"
              class="searchBtns"
              @click="getElderlyInfoList"
              >查询
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </global-tag>
    <div>
      <div class="btn_group" style="margin: 20px 0">
        <el-button-group>
          <el-button
            type="success"
            icon="el-icon-plus"
            class="openBtns"
            @click="showDialog('新增评估')"
            >新增评估
          </el-button>
        </el-button-group>
      </div>
      <div>
        <el-table
          border
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{
            background: '#f2f2f2',
            color: '#000',
          }"
        >
          <!-- <el-table-column
                        prop="intoNum"
                        width="120"
                        label="入院编号"
                        align="center"
                        :show-overflow-tooltip="true"
                        v-if="
                            this.choiceList.findIndex(
                                (item) => item == '入院编号'
                            ) != -1
                        "
                    >
                    </el-table-column> -->
          <el-table-column
            prop="customerName"
            label="姓名"
            align="center"
            :show-overflow-tooltip="true"
            v-if="this.choiceList.findIndex((item) => item == '姓名') != -1"
          >
          </el-table-column>
          <el-table-column
            prop="gender"
            label="性别"
            align="center"
            :show-overflow-tooltip="true"
            v-if="this.choiceList.findIndex((item) => item == '性别') != -1"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.gender == 0">男</span>
              <span v-if="scope.row.gender == 1">女</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="age"
            label="年龄"
            align="center"
            :show-overflow-tooltip="true"
            v-if="this.choiceList.findIndex((item) => item == '年龄') != -1"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号码"
            align="center"
            :show-overflow-tooltip="true"
            v-if="this.choiceList.findIndex((item) => item == '手机号码') != -1"
          >
          </el-table-column>
          <el-table-column
            prop="guardian"
            label="监护人"
            align="center"
            :show-overflow-tooltip="true"
            v-if="this.choiceList.findIndex((item) => item == '监护人') != -1"
          >
          </el-table-column>
          <el-table-column
            prop="guardianTel"
            label="联系方式"
            align="center"
            :show-overflow-tooltip="true"
            v-if="this.choiceList.findIndex((item) => item == '联系方式') != -1"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="300"
            v-if="this.choiceList.findIndex((item) => item == '操作') != -1"
          >
            <template slot-scope="scope">
              <el-row>
                <el-col :span="5">
                  <el-link
                    :underline="false"
                    @click="showDialog('查看', scope.row)"
                    >查看
                  </el-link>
                </el-col>
                <el-col :span="5">
                  <el-link :underline="false" @click="evaluate(scope.row)"
                    >评估结果
                  </el-link>
                </el-col>
                <el-col :span="5">
                  <el-link :underline="false" @click="deleteItem(scope.row)"
                    >删除
                  </el-link>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="1100px"
      class="dialog_container"
      @close="dialogVisibleClone1"
    >
      <div style="height: 1px"></div>
      <div class="name-per">
        <div
          v-for="(item, index) in titleList"
          :key="index"
          class="name-list"
          @click="changeIdx(item.id)"
        >
          <div>
            <div
              class="name-title"
              :class="{
                changeColor: controlAddContent == item.id,
              }"
            >
              <div></div>
              <div>
                <i class="el-icon-circle-check" style="font-size: 15px"></i>
              </div>
              <div></div>
            </div>
            <div class="name-bottom">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <el-form
        :model="formData"
        label-width="90px"
        :disabled="dialogTitle == '查看'"
        ref="addformRef"
        :rules="formDateRules"
      >
        <div
          v-show="controlAddContent == 1"
          disabled
          style="margin-bottom: 20px"
        >
          <div class="addBox">
            <div class="divLeft">
              <el-form-item label="姓名:" prop="customerName">
                <el-input
                  placeholder="请点击搜索"
                  v-model="formData.customerName"
                  style="width: 300px"
                  @click.native="showPerson()"
                >
                </el-input>
              </el-form-item>
              <el-form-item label="性别:" disabled prop="gender">
                <el-select
                  placeholder="请输入"
                  disabled
                  v-model="formData.gender"
                  style="width: 300px"
                >
                  <el-option value="0" label="男"></el-option>
                  <el-option value="1" label="女"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="身份证号:" prop="idCard">
                <el-input
                  placeholder="请输入"
                  disabled
                  v-model="formData1.idCard"
                  @change="idCardchange"
                ></el-input>
              </el-form-item>
              <el-form-item label="年龄:">
                <el-input
                  placeholder="获取数据"
                  disabled
                  v-model="formData.age"
                ></el-input>
              </el-form-item>
              <el-form-item label="出生日期:">
                <el-input
                  placeholder="获取数据"
                  disabled
                  v-model="formData1.birthday"
                ></el-input>
              </el-form-item>
            </div>
            <div class="divLeft" style="margin-left: 30%">
              <el-upload
                disabled
                ref="uploadAvatar"
                v-show="uploadShow == 1"
                class="avatar-uploader"
                :action="actionUrl"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="formData1.portraitImg"
                  :src="formData1.portraitImg"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="camera_outer" v-show="uploadShow == 2">
                <video
                  id="videoCamera"
                  :width="videoWidth"
                  :height="videoHeight"
                  autoplay
                ></video>
                <canvas
                  style="display: none"
                  id="canvasCamera"
                  :width="videoWidth"
                  :height="videoHeight"
                ></canvas>
                <div v-if="imgSrc" class="img_bg_camera">
                  <img :src="imgSrc" alt="" class="tx_img" />
                </div>
                <button @click="getCompetence()">打开摄像头</button>
                <button @click="stopNavigator()">关闭摄像头</button>
                <button @click="setImage()">拍照</button>
              </div>
              <div style="margin-left: 5px; margin-top: 20px">
                <el-button
                  disabled
                  :type="uploadShow == 1 ? 'primary' : 'info'"
                  @click="uploadShow = 1"
                  style="width: 170px"
                >
                  上传图片
                </el-button>
                <!-- <el-button
                                    size="mini"
                                    disabled
                                    :type="uploadShow == 1 ? 'info' : 'primary'"
                                    @click="uploadShow = 2"
                                >
                                    人脸库
                                </el-button> -->
              </div>
            </div>
          </div>
          <div style="display: flex">
            <el-form-item label="手机号码" prop="phone">
              <el-input
                placeholder="请输入"
                disabled
                v-model="formData.phone"
                style="width: 220px"
              ></el-input>
            </el-form-item>
            <el-form-item label="类别" prop="elderlyBelongCategory">
              <!-- <el-select placeholder="请选择" disabled v-model="formData.personType" style="width: 220px;">
                <el-option :value="0" label="退役军人"></el-option>
                <el-option :value="1" label="低保人员"></el-option>
                <el-option :value="2" label="三无人员"></el-option>
              </el-select> -->
              <el-select
                v-model="formData1.elderlyBelongCategory"
                placeholder="请选择"
                style="width: 250px"
                disabled
              >
                <el-option
                  v-for="(item, index) in personnelTypeList"
                  :key="index"
                  :label="item.dictLabel"
                  :value="item.dictCode"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="户籍地址:" prop="address">
            <el-select
              v-model="formData1.provinceId"
              placeholder="请选择省"
              @change="handleProvince"
              style="width: 20%"
              ref="selectShengChange"
              disabled
            >
              <el-option
                v-for="(item, index) in provinceList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="formData1.cityId"
              placeholder="请选择市"
              disabled
              @change="handleCity"
              ref="selectShiChange"
              style="width: 20%"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.name"
                :value="item.adcode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="formData1.areaId"
              placeholder="请选择区"
              disabled
              @change="handleArea"
              ref="selectQuChange"
              style="width: 20%"
            >
              <el-option
                v-for="(item, index) in areaList"
                :key="index"
                :label="item.addName"
                :value="item.addCode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="formData1.streetId"
              placeholder="请选择街道"
              @change="streetChange"
              disabled
              style="width: 20%"
              ref="selectJiedaoChange"
            >
              <el-option
                v-for="(item, index) in streetList"
                :key="index"
                :label="item.addName"
                :value="item.addCode"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="formData1.communityId"
              placeholder="请选择社区"
              ref="selectShequChange"
              disabled
              style="width: 20%"
              @change="handleCommunityChange"
            >
              <el-option
                v-for="item in communityList"
                :key="item.addCode"
                :label="item.addName"
                :value="+item.addCode"
              >
              </el-option>
            </el-select>
            <el-input
              label="请输入地址"
              disabled
              style="margin-top: 10px"
              v-model="formData1.address"
              id="tipinput"
              @focus="getMap('tipinput')"
            ></el-input>
            <div class="map_container" style="margin-bottom: 20px">
              <div id="container" style="width: 100%; height: 200px"></div>
            </div>
          </el-form-item>
          <!-- <div
                        style="display: flex"
                        v-for="(item, index) in formData1.emergencyContactList"
                        :key="index"
                    >
                        <el-form-item label="紧急联系人:">
                            <el-input
                                placeholder="请输入"
                                v-model="item.name"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="联系方式:">
                            <el-input
                                placeholder="请输入"
                                v-model="item.phone"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="与老人关系:">
                            <el-select
                                placeholder="请选择"
                                v-model="item.relationship"
                            >
                                <el-option
                                    v-for="item in oldList"
                                    :key="item.value"
                                    :value="item.value"
                                    :label="item.label"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-button
                            v-if="index === 0"
                            type="white"
                            icon="el-icon-plus"
                            style="margin-left: 20px; height: 40px"
                            size="mini"
                            @click="addItem"
                        ></el-button>
                        <el-button
                            v-else
                            type="white"
                            icon="el-icon-minus"
                            style="margin-left: 20px; height: 40px"
                            size="mini"
                            @click="removeItem(index)"
                        ></el-button>
                    </div> -->
        </div>
        <div v-show="controlAddContent == 2" style="margin-bottom: 20px">
          <p style="color: #409eff">日常生活能力评估</p>
          <hr />
          <div style="display: flex; margin-top: 15px">
            <el-form-item label="穿衣:" prop="dressing">
              <el-radio-group v-model="formData.dressing">
                <el-radio label="10">可独立完成(10分)</el-radio>
                <br />
                <el-radio label="5">需要帮助(5分)</el-radio>
                <br />
                <el-radio label="0">完全依赖他人(0分)</el-radio>
                <br />
                <!-- <el-radio label="3">其他(0分)</el-radio><br /> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="进食:" prop="eat">
              <el-radio-group v-model="formData.eat">
                <el-radio label="10">在合理的时间可以独立进食(10分) </el-radio>
                <br />
                <el-radio label="5">需要部分帮助(5分)</el-radio>
                <br />
                <el-radio label="0">需极大帮助(0分)</el-radio>
                <br />
                <!-- <el-radio label="3">其他(0分)</el-radio> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="如厕:" prop="toilet">
              <el-radio-group v-model="formData.toilet">
                <el-radio label="10">自行去厕所(10分)</el-radio>
                <br />
                <el-radio label="5">床旁使用便器，需要帮助(5分) </el-radio>
                <br />
                <el-radio label="0">人工助便，需要帮助(0分) </el-radio>
                <br />
                <!-- <el-radio label="3">其他(0分)</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: flex">
            <el-form-item label="床椅转移:" prop="transfer">
              <el-radio-group v-model="formData.transfer">
                <el-radio label="15">可独立完成(15分)</el-radio>
                <br />
                <el-radio label="10">需少部分帮助(10分) </el-radio>
                <br />
                <el-radio label="5">需大帮助(5分)</el-radio>
                <br />
                <el-radio label="0">完全依赖他人(0分)</el-radio>
                <br />
                <!-- <el-radio label="4">其他(0分)</el-radio><br /> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="平地行走:" prop="walk">
              <el-radio-group v-model="formData.walk">
                <el-radio label="15">可独立平地上行走45m以上(15分) </el-radio>
                <br />
                <el-radio label="10">需少部分帮助(10分) </el-radio>
                <br />
                <el-radio label="5">需极大帮助(5分)</el-radio>
                <br />
                <el-radio label="0">完全依赖他人(0分)</el-radio>
                <br />
                <!-- <el-radio label="4">其他(0分)</el-radio><br /> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="修饰盥洗:" prop="modification">
              <el-radio-group v-model="formData.modification">
                <el-radio label="15">独立完成(15分)</el-radio>
                <br />
                <el-radio label="10">需少部分帮助(10分) </el-radio>
                <br />
                <el-radio label="5">需极大帮助(5分)</el-radio>
                <br />
                <el-radio label="0">完全依赖他人(0分)</el-radio>
                <br />
                <!-- <el-radio label="4">其他(0分)</el-radio><br /> -->
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: flex; margin-top: 15px">
            <el-form-item label="上下楼梯:" style="width: 33%" prop="stairs">
              <el-radio-group v-model="formData.stairs">
                <el-radio label="10">可独立上下楼梯(10分) </el-radio>
                <br />
                <el-radio label="5">需要帮助(5分)</el-radio>
                <br />
                <el-radio label="0">完全依赖他人(0分)</el-radio>
                <br />
                <!-- <el-radio label="3">其他(0分)</el-radio><br /> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="洗澡:" style="width: 33%" prop="shower">
              <el-radio-group v-model="formData.shower">
                <el-radio label="10">可独立完成(10分)</el-radio>
                <br />
                <el-radio label="5">需要帮助(5分)</el-radio>
                <br />
                <el-radio label="0">完全依赖他人(0分)</el-radio>
                <br />
                <!-- <el-radio label="3">其他(0分)</el-radio><br /> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="大便控制:" style="width: 33%" prop="shit">
              <el-radio-group v-model="formData.shit">
                <el-radio label="10">可控制大便(10分)</el-radio>
                <br />
                <el-radio label="5">偶尔控制(5分)</el-radio>
                <br />
                <el-radio label="0">完全失控(0分)</el-radio>
                <br />
                <!-- <el-radio label="3">其他(0分)</el-radio> -->
              </el-radio-group>
            </el-form-item>
          </div>

          <el-form-item label="小便控制:" prop="urine">
            <el-radio-group v-model="formData.urine">
              <el-radio label="10">可控制小便(10分)</el-radio>
              <br />
              <el-radio label="5">偶尔控制(5分)</el-radio>
              <br />
              <el-radio label="0">完全失控(0分)</el-radio>
              <br />
            </el-radio-group>
          </el-form-item>
          <p style="color: #409eff">感知觉与沟通能力评估</p>
          <hr />
          <div style="display: flex">
            <el-form-item label="裸视视力" prop="vision">
              <el-radio-group v-model="formData.vision">
                <el-radio label="4"
                  >距离远视力表5m能辨清第一行一下视力标(4分)
                </el-radio>
                <br />
                <el-radio label="3"
                  >距离远视力表<5米>1米能辨清第一行一下视力标(3分)
                </el-radio>
                <br />
                <el-radio label="2"
                  >距离远视力表<1米>0.5米能辨清第一行一下视力标(2分)
                </el-radio>
                <br />
                <el-radio label="1"
                  >视力辨别指数<50厘米,或仅有手动,光感(1分)
                </el-radio>
                <br />
                <el-radio label="0"
                  >光感投照不准或无光感，提供伤残鉴定机构证书(0分)
                </el-radio>
                <br />
                <!-- <el-radio :label="5">其他(0分)</el-radio><br /> -->
              </el-radio-group>
            </el-form-item>
            <el-form-item label="沟通交流:" prop="communication">
              <el-radio-group v-model="formData.communication">
                <el-radio label="3">无困难，能与他人正常交流(3分) </el-radio>
                <br />
                <el-radio label="2"
                  >能够表达需求及理解别人的话语(2分)
                </el-radio>
                <br />
                <el-radio label="1"
                  >表达需求或理解别人的话语有困难，需复解释，<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;回应不完全正确(1分)
                </el-radio>
                <br />
                <el-radio label="0"
                  >完全不能表达需求或不理解别人的话语(0分)
                </el-radio>
                <br />
                <!-- <el-radio label="0">其他(0分)</el-radio><br /> -->
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="听力:" prop="hearing">
            <el-radio-group v-model="formData.hearing">
              <el-radio label="4"
                >可正常交谈，能听到电视机、电话、门铃的声音，距离声源6米处，平均听在40-55分贝(4分)
              </el-radio>
              <br />
              <el-radio label="3"
                >距离超过2米时听不清，距离声源6米处，平均听在71-90分贝(3分)
              </el-radio>
              <br />
              <el-radio label="2"
                >正常交流有些困难，需要在安静的环境或大声说话才能听到。距离声源6米处，平均听在71-90分贝(2分)
              </el-radio>
              <br />
              <el-radio label="1"
                >是讲话者大声说话或说话很慢，才能部分听见。距离声源6米处，平均听大于90分贝(1分)
              </el-radio>
              <el-radio label="0"
                >完全听不见，提供伤残机构鉴定书(0分)
              </el-radio>
              <br />
              <!-- <el-radio label="5">其他(0分)</el-radio><br /> -->
            </el-radio-group>
          </el-form-item>
          <p style="color: #409eff">近30天内意外事件</p>
          <hr />
          <div style="display: flex; margin-top: 15px">
            <el-form-item label="跌倒:" style="width: 50%" prop="fall">
              <el-radio-group v-model="formData.fall">
                <el-radio label="0">发生过3次及以上</el-radio>
                <br />
                <el-radio label="1">发生过2次</el-radio>
                <br />
                <el-radio label="2">发生过1次</el-radio>
                <br />
                <el-radio label="3">无</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="走失:" style="width: 50%" prop="beLost">
              <el-radio-group v-model="formData.beLost">
                <el-radio label="0">发生过3次及以上</el-radio>
                <br />
                <el-radio label="1">发生过2次</el-radio>
                <br />
                <el-radio label="2">发生过1次</el-radio>
                <br />
                <el-radio label="3">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: flex">
            <el-form-item label="嗑食:" style="width: 50%" prop="choking">
              <el-radio-group v-model="formData.choking">
                <el-radio label="0">发生过3次及以上</el-radio>
                <br />
                <el-radio label="1">发生过2次</el-radio>
                <br />
                <el-radio label="2">发生过1次</el-radio>
                <br />
                <el-radio label="3">无</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自杀:" style="width: 50%" prop="commitSuicide">
              <el-radio-group v-model="formData.commitSuicide">
                <el-radio label="0">发生过3次及以上</el-radio>
                <br />
                <el-radio label="1">发生过2次</el-radio>
                <br />
                <el-radio label="2">发生过1次</el-radio>
                <br />
                <el-radio label="3">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: flex">
            <el-form-item
              label="老年痴呆:"
              style="width: 50%"
              prop="senileDementia"
            >
              <el-radio-group v-model="formData.senileDementia">
                <el-radio label="0">重度</el-radio>
                <br />
                <el-radio label="1">中度</el-radio>
                <br />
                <el-radio label="2">轻度</el-radio>
                <br />
                <el-radio label="3">无</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="精神疾病:"
              style="width: 50%"
              prop="mentalIllness"
            >
              <el-radio-group v-model="formData.mentalIllness">
                <el-radio label="0">重度</el-radio>
                <br />
                <el-radio label="1">中度</el-radio>
                <br />
                <el-radio label="2">轻度</el-radio>
                <br />
                <el-radio label="3">无</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" v-if="dialogTitle != '查看'" @click="send"
          >确 定</el-button
        >
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 评估结果 -->
    <el-dialog
      title="评估结果"
      :visible.sync="addDialogVisible"
      width="50%"
      id="chatRecord"
      class="dialog_container"
      @close="dialogVisibleClone"
    >
      <div ref="print" class="s">
        <img alt src="../../assets/img/1111.png" style="width: 100%" />
        <div style="text-align: center">
          <h1 style="font-size: 40px; font-weight: 600; margin-top: 20%">
            老年人生活能力评估报告
          </h1>
        </div>
        <div
          class="padapply"
          style="margin-left: 40%; font-size: 20px; margin-top: 40px"
        >
          <p>申请人姓名: {{ queryForm1.customerName }}</p>
        </div>
        <h2
          style="
            font-size: 26px;
            color: #000000;
            font-weight: 500;
            margin-left: 40%;
            margin-top: 10%;
          "
        >
          知情同意书
        </h2>
        <div class="authorization">
          <p>1.本人自愿申请能力评估，积极配合评估工作</p>
          <p>2.本人承认提供的信息资料真实，准确</p>
          <p>3.本人同意对评估过程进行影响采集记录，纳入评估管理档案</p>
        </div>
        <div style="display: flex; margin-top: 20px">
          <p style="margin-left: 10%; font-size: 18px">
            申请人/代理人：{{ queryForm1.name }}
          </p>
          <p style="margin-left: 35%; font-size: 18px">
            {{ queryForm.createDate }}
          </p>
        </div>
        <h2
          style="
            font-weight: 600;
            margin-left: 46%;
            margin-top: 8%;
            margin-buttom: 2%;
            font-size: 24px;
          "
        >
          基本信息
        </h2>
        <div ref="print" class="print_container dialog_content">
          <table class="table_container">
            <tr class="user_info">
              <td style="padding: 15px 0">姓名</td>
              <td style="width: 270px" colspan="3">
                {{ queryForm1.customerName }}
              </td>
              <td style="padding: 15px 0">性别</td>
              <td style="width: 270px" colspan="3">
                <span v-if="queryForm1.gender == 0">男</span>
                <span v-if="queryForm1.gender == 1">女</span>
              </td>
            </tr>
            <tr class="user_info">
              <td style="padding: 15px 0">身份证号</td>
              <td colspan="3">{{ queryForm1.idCard }}</td>
              <td class="label" style="padding: 15px 0">出生日期</td>
              <td class="content" colspan="3">
                {{ queryForm1.birthday }}
              </td>
            </tr>
            <tr class="user_info">
              <td class="label" style="padding: 15px 0">移动电话</td>
              <td class="content" colspan="3">
                {{ queryForm1.phone }}
              </td>
              <td class="label" style="padding: 15px 0">固定电话</td>
              <td class="content" colspan="3">
                {{ queryForm1.familyCall }}
              </td>
            </tr>
            <tr class="user_info">
              <td class="label" style="padding: 15px 0">居住地址</td>
              <td class="content" colspan="7">
                {{ queryForm1.address }}
              </td>
            </tr>
            <tr class="user_info"></tr>
            <template>
              <tr class="inner-tr">
                <td style="padding: 12px 0">监护人姓名</td>
                <td colspan="3">{{ queryForm1.guardian }}</td>
                <td style="padding: 12px 0">关系</td>
                <td colspan="3">
                  <span>{{ queryForm1.guardianRelationshipName }}</span>
                </td>
              </tr>
              <!-- <tr class="inner-tr">
                                <td style="padding: 12px 0">地址</td>
                                <td colspan="7">{{ queryForm1.address }}</td>
                            </tr> -->
            </template>
            <!-- <tr class="user_info">
              <td style="padding: 10px 0" class="label">疾病诊断</td>
              <td class="content" colspan="7"></td>
            </tr> -->
            <tr class="inner-tr">
              <td style="padding: 10px 0">痴呆</td>
              <td colspan="7">
                <span v-if="queryForm.senileDementia == 3">无</span>
                <span v-if="queryForm.senileDementia == 2">轻度</span>
                <span v-if="queryForm.senileDementia == 1">中度</span>
                <span v-if="queryForm.senileDementia == 0">重度</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td style="padding: 10px 0">精神疾病</td>
              <td colspan="7">
                <span v-if="queryForm.mentalIllness == 3">无</span>
                <span v-if="queryForm.mentalIllness == 2">轻度</span>
                <span v-if="queryForm.mentalIllness == 1">中度</span>
                <span v-if="queryForm.mentalIllness == 0">重度</span>
              </td>
            </tr>
          </table>

          <h2 style="font-size: 30px; margin-left: 35%; margin-top: 6%">
            感知觉与沟通能力评估表
          </h2>
          <table class="table_container">
            <tr class="user_info">
              <td class="label" rowspan="5">裸眼视力/矫正视力</td>
              <td colspan="3" style="padding: 10px 0">
                光感投照不准或无光感，提供伤残鉴定机构证书
              </td>
              <td style="width: 50px">0分</td>
              <td class="label" rowspan="1">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                视力辨别指数<50厘米,或仅有手动,光感
              </td>
              <td>1分</td>
              <td class="label" rowspan="4">
                <span v-if="queryForm.vision == 4">4分</span>
                <span v-if="queryForm.vision == 3">3分</span>
                <span v-if="queryForm.vision == 2">2分</span>
                <span v-if="queryForm.vision == 1">1分</span>
                <span v-if="queryForm.vision == 0">0分</span>
                <span v-if="queryForm.vision == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                距离远视力表<1米>0.5米能辨清第一行一下视力标
              </td>
              <td>2分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                距离远视力表<5米>1米能辨清第一行一下视力标
              </td>
              <td>3分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                距离远视力表5m能辨清第一行一下视力标
              </td>
              <td>4分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="5">听力/矫正听力</td>
              <td colspan="3" style="padding: 10px 0">
                完全听不见，提供伤残机构鉴定书
              </td>
              <td>0分</td>
              <td class="label" rowspan="1">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                是讲话者大声说话或说话很慢，才能部分听见。距离声源6米处，平均听大于90分贝
              </td>
              <td>1分</td>
              <td class="label" rowspan="4">
                <span v-if="queryForm.hearing == 4">4分</span>
                <span v-if="queryForm.hearing == 3">3分</span>
                <span v-if="queryForm.hearing == 2">2分</span>
                <span v-if="queryForm.hearing == 1">1分</span>
                <span v-if="queryForm.hearing == 0">0分</span>
                <span v-if="queryForm.hearing == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                正常交流有些困难，需要在安静的环境或大声说话才能听到。距离声源6米处，平均听在71-90分贝
              </td>
              <td>2分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                距离超过2米时听不清，距离声源6米处，平均听在71-90分贝(3分)
              </td>
              <td>3分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                可正常交谈，能听到电视机、电话、门铃的声音，距离声源6米处，平均听在40-55分贝
              </td>
              <td>4分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="4">沟通交流</td>
              <td colspan="3" style="padding: 10px 0">
                完全不能表达需求或不理解别人的话语
              </td>
              <td style="width: 50px">0分</td>
              <td class="label" rowspan="1">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                表达需求或理解别人的话语有困难，需复解释，回应不完全正确
              </td>
              <td>1分</td>
              <td class="label" rowspan="3">
                <span v-if="queryForm.communication == 3">3分</span>
                <span v-if="queryForm.communication == 2">2分</span>
                <span v-if="queryForm.communication == 1">1分</span>
                <span v-if="queryForm.communication == 0">0分</span>
                <span v-if="queryForm.communication == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                能够表达需求及理解别人的话语
              </td>
              <td>2分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                无困难，能与他人正常交流
              </td>
              <td>3分</td>
            </tr>

            <tr class="user_info">
              <td class="label">总分</td>
              <td colspan="5" style="padding: 10px 0">
                {{
                  Number(queryForm.communication) +
                  Number(queryForm.vision) +
                  Number(queryForm.hearing)
                }}
              </td>
            </tr>
            <tr class="user_info">
              <td class="label">受损</td>
              <td colspan="5" style="padding: 10px 0">
                1.重度受损：听力或视力评为0或1分，沟通评为0分<br />
                2.中度受损：听力和视力至少一项评为2分，沟通评为1分<br />
                3.轻度受损：听力和视力至少一项评为3分，沟通评为2分<br />
                4.能力完好：听力和视力至少一项评为4分，沟通评为3分<br />
              </td>
            </tr>
          </table>
          <h2 style="font-size: 30px; margin-left: 35%; margin-top: 6%">
            日常生活能力评估表
          </h2>
          <table class="table_container">
            <tr class="user_info">
              <td class="label" rowspan="3">穿衣</td>
              <td class="label" rowspan="3">
                指穿脱衣服，包括系扣，拉拉链，穿脱鞋袜
              </td>
              <td colspan="3" style="padding: 10px 0">可独立完成</td>
              <td style="width: 50px">10分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需要帮助</td>
              <td>5分</td>
              <td class="label" rowspan="2">
                <span v-if="queryForm.dressing == 10">10分</span>
                <span v-if="queryForm.dressing == 5">5分</span>
                <span v-if="queryForm.dressing == 0">0分</span>
                <span v-if="queryForm.dressing == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全依赖他人</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="3">进食(水)</td>
              <td class="label" rowspan="3">
                指用餐具将加工适应的食物用容器送到口中，咽下去的过程
              </td>
              <td colspan="3" style="padding: 10px 0">
                在合理的时间可以独立进食
              </td>
              <td>10分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需要部分帮助</td>
              <td>5分</td>
              <td class="label" rowspan="2">
                <span v-if="queryForm.eat == 10">10分</span>
                <span v-if="queryForm.eat == 5">5分</span>
                <span v-if="queryForm.eat == 0">0分</span>
                <span v-if="queryForm.eat == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需极大帮助</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="4">床椅转移</td>
              <td class="label" rowspan="4">指从床上到轮椅然后回来的全过程</td>
              <td colspan="3" style="padding: 10px 0">可独立完成</td>
              <td>15分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需少部分帮助</td>
              <td>10分</td>
              <td class="label" rowspan="3">
                <span v-if="queryForm.transfer == 10">10分</span>
                <span v-if="queryForm.transfer == 15">15分</span>
                <span v-if="queryForm.transfer == 5">5分</span>
                <span v-if="queryForm.transfer == 0">0分</span>
                <span v-if="queryForm.transfer == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">极大帮助</td>
              <td>5分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全依赖他人</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="4">平地行走</td>
              <td class="label" rowspan="4">指在院内，屋内活动可借助工具</td>
              <td colspan="3" style="padding: 10px 0">可独立完成</td>
              <td>15分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需少部分帮助</td>
              <td>10分</td>
              <td class="label" rowspan="3">
                <span v-if="queryForm.walk == 15">15分</span>
                <span v-if="queryForm.walk == 10">10分</span>
                <span v-if="queryForm.walk == 5">5分</span>
                <span v-if="queryForm.walk == 0">0分</span>
                <span v-if="queryForm.walk == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">极大帮助</td>
              <td>5分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全依赖他人</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="4">修饰盥洗</td>
              <td class="label" rowspan="4">指在院内，屋内活动可借助工具</td>
              <td colspan="3" style="padding: 10px 0">可独立完成</td>
              <td>15分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需少部分帮助</td>
              <td>10分</td>
              <td class="label" rowspan="3">
                <span v-if="queryForm.modification == 15">15分</span>
                <span v-if="queryForm.modification == 10">10分</span>
                <span v-if="queryForm.modification == 5">5分</span>
                <span v-if="queryForm.modification == 0">0分</span>
                <span v-if="queryForm.modification == null">0分</span>
              </td>
            </tr>

            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需极大帮助</td>
              <td>5分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全依赖他人</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label">总分</td>
              <td colspan="6" style="padding: 10px 0">
                {{
                  Number(queryForm.dressing) +
                  Number(queryForm.eat) +
                  Number(queryForm.transfer) +
                  Number(queryForm.walk) +
                  Number(queryForm.modification)
                }}
              </td>
            </tr>
            <tr class="user_info">
              <td class="label">受损</td>
              <td colspan="6" style="padding: 10px 0">
                1.重度受损：总分0-20<br />
                2.中度受损：总分21-40<br />
                3.轻度受损：总分41-60<br />
                4.能力完好：总分61-65<br />
              </td>
            </tr>
          </table>
          <table class="table_container">
            <tr class="user_info">
              <td class="label" rowspan="3">如厕</td>
              <td class="label" rowspan="3">
                包括厕所解开衣裤，擦净，整理衣裤，冲水(倒掉)
              </td>
              <td colspan="3" style="padding: 10px 0">自行去厕所</td>
              <td>10分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">
                床旁使用便器，部分需要帮助
              </td>
              <td>5分</td>
              <td class="label" rowspan="2">
                <span v-if="queryForm.toilet == 10">10分</span>
                <span v-if="queryForm.toilet == 5">5分</span>
                <span v-if="queryForm.toilet == 0">0分</span>
                <span v-if="queryForm.toilet == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全依赖他人</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="3">上下楼梯</td>
              <td class="label" rowspan="3"></td>
              <td colspan="3" style="padding: 10px 0">可独立上下楼梯</td>
              <td>10分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需要帮助</td>
              <td>5分</td>
              <td class="label" rowspan="2">
                <span v-if="queryForm.stairs == 10">10分</span>
                <span v-if="queryForm.stairs == 5">5分</span>
                <span v-if="queryForm.stairs == 0">0分</span>
                <span v-if="queryForm.stairs == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全依赖他人</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="3">洗澡</td>
              <td class="label" rowspan="3">
                与洗澡的方式和沐浴的种类无关，包括更衣及移动
              </td>
              <td colspan="3" style="padding: 10px 0">可独立完成</td>
              <td>10分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">需要帮助</td>
              <td>5分</td>
              <td class="label" rowspan="2">
                <span v-if="queryForm.shower == 10">10分</span>
                <span v-if="queryForm.shower == 5">5分</span>
                <span v-if="queryForm.shower == 0">0分</span>
                <span v-if="queryForm.shower == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全依赖他人</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="3">大便控制</td>
              <td class="label" rowspan="3"></td>
              <td colspan="3" style="padding: 10px 0">可以控制</td>
              <td>10分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">偶尔失控</td>
              <td>5分</td>
              <td class="label" rowspan="2">
                <span v-if="queryForm.shit == 10">10分</span>
                <span v-if="queryForm.shit == 5">5分</span>
                <span v-if="queryForm.shit == 0">0分</span>
                <span v-if="queryForm.shit == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全失控</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label" rowspan="3">小便控制</td>
              <td class="label" rowspan="3"></td>
              <td colspan="3" style="padding: 10px 0">可控制小便</td>
              <td>10分</td>
              <td class="label">评分</td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">偶尔失控</td>
              <td>5分</td>
              <td class="label" rowspan="2">
                <span v-if="queryForm.urine == 10">10分</span>
                <span v-if="queryForm.urine == 5">5分</span>
                <span v-if="queryForm.urine == 0">0分</span>
                <span v-if="queryForm.urine == null">0分</span>
              </td>
            </tr>
            <tr class="inner-tr">
              <td colspan="3" style="padding: 10px 0">完全失控</td>
              <td>0分</td>
            </tr>
            <tr class="user_info">
              <td class="label">总分</td>
              <td colspan="6" style="padding: 10px 0">
                {{
                  Number(queryForm.toilet) +
                  Number(queryForm.stairs) +
                  Number(queryForm.shower) +
                  Number(queryForm.shit) +
                  Number(queryForm.urine)
                }}
              </td>
            </tr>
            <tr class="user_info">
              <td class="label">受损</td>
              <td colspan="6" style="padding: 10px 0">
                1.重度受损：总分0-15<br />
                2.中度受损：总分16-30<br />
                3.轻度受损：总分31-45<br />
                4.能力完好：总分45-50<br />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer btnSite">
        <el-button type="primary" @click="handlePrint">打印</el-button>
        <el-button @click="addDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="人员信息"
      :visible.sync="addVisible"
      width="40%"
      :before-close="handleClose1"
    >
      <div>
        <div class="search_wrapper">
          <div class="search_head">
            <span>查询条件</span>
            <i
              class="searchDomw"
              @click="isSearchContent = !isSearchContent"
              :class="
                isSearchContent == true
                  ? 'el-icon-arrow-up'
                  : 'el-icon-arrow-down'
              "
            ></i>
          </div>
          <div class="search_content" v-show="isSearchContent">
            <div class="search_inline">
              <el-form :model="queryInfo1" label-width="90px">
                <el-row type="flex" justify="start">
                  <el-col :span="9">
                    <el-form-item label="姓名：">
                      <el-input
                        clearable
                        v-model="queryInfo1.name"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="9">
                    <el-form-item label="手机号码：">
                      <el-input
                        clearable
                        v-model="queryInfo1.phone"
                        placeholder="请输入"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="2" :offset="2">
                    <el-button size="mini" type="primary" @click="QuerySearch1"
                      >查询
                    </el-button>
                  </el-col>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div style="margin-top: 20px">
        <el-table
          :data="fromTable"
          ref="myTable"
          :header-cell-style="{
            background: '#f2f2f2',
            color: '#000',
          }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- <el-table-column
                        prop="intoNum"
                        label="入院编号"
                        width="200"
                        align="center"
                    ></el-table-column> -->
          <el-table-column
            prop="customerName"
            label="姓名"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="联系方式"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="age"
            label="年龄"
            align="center"
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange1"
          @current-change="handleCurrentChange1"
          :page-sizes="[10, 20, 40, 100]"
          :page-size="query1.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total1"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addPersonName" size="small"
          >确 定</el-button
        >
        <el-button size="small" @click="addVisible = false">取 消</el-button>
      </span>
      <!-- <span class="dialog-footer" style="margin-left: 40%">
        <el-button
          type="primary"
          @click="addPersonName"
          size="small"
          >确 定</el-button
        >
        <el-button size="small" @click="addVisible = false">取 消</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import baseURL from "@/api/baseURL"
import request from "@/utils/request.js"

export default {
  components: {},
  data() {
    return {
      oldList: [
        {
          value: 1,
          label: "配偶",
        },
        {
          value: 2,
          label: "父母",
        },
        {
          value: 3,
          label: "子女",
        },
        {
          value: 4,
          label: "兄弟",
        },
        {
          value: 5,
          label: "姐妹",
        },
      ],
      formDateRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "input" }],
        dressing: [{ required: true, message: "请选择穿衣", trigger: "blur" }],
        eat: [{ required: true, message: "请选择进食", trigger: "blur" }],
        toilet: [{ required: true, message: "请选择如厕", trigger: "blur" }],
        transfer: [
          {
            required: true,
            message: "请选择床椅转移",
            trigger: "blur",
          },
        ],
        walk: [
          {
            required: true,
            message: "请选择平地行走",
            trigger: "blur",
          },
        ],
        modification: [
          {
            required: true,
            message: "请选择修饰盥洗",
            trigger: "blur",
          },
        ],
        stairs: [
          {
            required: true,
            message: "请选择上下楼梯",
            trigger: "blur",
          },
        ],
        shower: [{ required: true, message: "请选择洗澡", trigger: "blur" }],
        shit: [
          {
            required: true,
            message: "请选择大便控制",
            trigger: "blur",
          },
        ],
        urine: [
          {
            required: true,
            message: "请选择小便控制",
            trigger: "blur",
          },
        ],
        vision: [
          {
            required: true,
            message: "请选择裸视视力",
            trigger: "blur",
          },
        ],
        communication: [
          {
            required: true,
            message: "请选择沟通交流",
            trigger: "blur",
          },
        ],
        hearing: [{ required: true, message: "请选择听力", trigger: "blur" }],
        fall: [{ required: true, message: "请选择跌倒", trigger: "blur" }],
        beLost: [{ required: true, message: "请选择走失", trigger: "blur" }],
        choking: [{ required: true, message: "请选择嗑食", trigger: "blur" }],
        commitSuicide: [
          { required: true, message: "请选择自杀", trigger: "blur" },
        ],
        senileDementia: [
          {
            required: true,
            message: "请选择老年痴呆",
            trigger: "blur",
          },
        ],
        mentalIllness: [
          {
            required: true,
            message: "请选择精神疾病",
            trigger: "blur",
          },
        ],
      },
      formData: {
        name: "",
        emergencyContactList: [
          {
            name: "",
            phone: "",
            relationship: "",
          },
        ],
      },
      formData1: {},
      queryForm1: {},
      total: 0,
      total1: 0,
      fromTable: [],
      isSearchContent: true,
      queryInfo1: {},
      myMap: null,
      isMap: true,
      actionUrl: "", // 图片上传地址
      uploadShow: 1,
      controlAddContent: 1,
      dialogVisible: false,
      addDialogVisible: false,
      titleList: [
        {
          id: "1",
          name: "基本信息",
        },
        {
          id: "2",
          name: "评估信息",
        },
      ],
      tapId: "1",
      dialogTitle: "", //table弹窗title
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      videoWidth: 250,
      videoHeight: 250,
      imgSrc: "",
      provinceList: [],
      multipleSelection: [],
      cityList: [],
      areaList: [],
      streetList: [],
      communityList: [],
      totalCount: 0,
      queryForm: {
        name: "", //老人姓名
      },
      searchObj: {
        status: "",
        name: "",
        phone: "",
        sex: "0",
      },
      personnelTypeList: [],
      tableData: [],
      query1: {
        pageNo: 1,
        pageSize: 10,
      },
      checkList: [
        // "入院编号",
        "姓名",
        "性别",
        "年龄",
        "手机号码",
        // "床位信息",
        "监护人",
        "联系方式",
        "操作",
      ],
      choiceList: [
        // "入院编号",
        "姓名",
        "性别",
        "年龄",
        "手机号码",
        // "床位信息",
        "监护人",
        "联系方式",
        "操作",
      ],
      addVisible: false,
    }
  },
  inject: ["reload"],
  created() {
    this.actionUrl =
      baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
    this.showList()
    this.getProvince()
  },
  methods: {
    // showOldList() {
    //     let params = {
    //         pageNo: 1,
    //         pageSize: 1000,
    //         type: "4",
    //         state: "1",
    //     }
    //     this.$http
    //         .request({
    //             url: "/jgyl/admin/serviceName/info/findList",
    //             method: "POST",
    //             data: params,
    //         })
    //         .then((res) => {
    //             if (res.code == 200) {
    //                 if (res.content == null || res.content == "null") {
    //                     this.oldList = []
    //                     return
    //                 }
    //                 this.oldList = res.content.list
    //             }
    //         })
    // },
    send() {
      this.$refs["addformRef"].validate((valid) => {
        if (valid) {
          this.submit()
        } else {
          this.$message.error("请按照提示正确输入")
          return false
        }
      })
    },
    submit() {
      if (this.dialogTitle == "新增评估") {
        this.formData.emergencyContactList = this.formData1.emergencyContactList
        this.$http
          .request({
            url: "/ypt/admin/assessment/info/insert",
            method: "POST",
            data: {
              ...this.formData,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              this.dialogVisible = false
              this.showList()
            }
          })
      }
    },
    dialogVisibleClone1() {
      this.dialogVisible = false
      this.$refs.addformRef.resetFields()
      this.reload()
    },
    async addPersonName() {
      this.addVisible = false
      const customerId = this.multipleSelection[0].id
      const customerName = this.multipleSelection[0].customerName
      const bedName = this.multipleSelection[0].bedName
      const intoNum = this.multipleSelection[0].intoNum
      const gender = this.multipleSelection[0].gender
      const idCard = this.multipleSelection[0].idCard
      const age = this.multipleSelection[0].age
      const birthday = this.multipleSelection[0].birthday
      const phone = this.multipleSelection[0].phone
      const familyCall = this.multipleSelection[0].familyCall
      const portraitImg = this.multipleSelection[0].portraitImg
      const elderlyBelongCategory =
        this.multipleSelection[0].elderlyBelongCategory
      const address = this.multipleSelection[0].address
      const guardian = this.multipleSelection[0].guardian
      const guardianTel = this.multipleSelection[0].guardianTel
      const guardianRelationship =
        this.multipleSelection[0].guardianRelationship
      const photo = this.multipleSelection[0].photo
      const provinceId = String(this.multipleSelection[0].provinceId)
      const cityId = String(this.multipleSelection[0].cityId)
      const areaId = String(this.multipleSelection[0].areaId)
      const streetId = String(this.multipleSelection[0].streetId)
      const communityId = this.multipleSelection[0].communityId
      this.formData1.communityId = communityId
      this.formData1.communityId = Number(this.formData1.communityId)
      const longitude = this.multipleSelection[0].longitude
      const latitude = this.multipleSelection[0].latitude
      const emergencyContactList =
        this.multipleSelection[0].emergencyContactList
      const idJust = this.multipleSelection[0].idJust
      const idBack = this.multipleSelection[0].idBack
      const hkbHome = this.multipleSelection[0].hkbHome
      const hkbOneself = this.multipleSelection[0].hkbOneself

      if (!provinceId) return
      this.getDistrict(provinceId).then((res) => {
        this.cityList = res.districtList
      })

      if (!cityId) return
      this.areaList = await this.getStreetList(cityId)
      if (!areaId) return
      let streetList = await this.getStreetList(areaId)
      this.streetList = streetList

      if (!streetId) return
      let communityList = await this.getStreetList(streetId)
      this.communityList = communityList
      this.$set(this.formData, "customerId", customerId)
      this.$set(this.formData, "idCard", idCard)
      this.$set(this.formData1, "idJust", idJust)
      this.$set(this.formData1, "idBack", idBack)
      this.$set(this.formData1, "hkbHome", hkbHome)
      this.$set(this.formData1, "hkbOneself", hkbOneself)
      this.$set(this.formData, "customerName", customerName)
      this.$set(this.formData, "bedName", bedName)
      this.$set(this.formData, "gender", gender)
      this.$set(this.formData, "intoNum", intoNum)
      this.$set(this.formData1, "idCard", idCard)
      this.$set(this.formData, "age", age)
      this.$set(this.formData1, "birthday", birthday)
      this.$set(this.formData1, "address", address)
      this.$set(this.formData1, "longitude", longitude)
      this.$set(this.formData1, "latitude", latitude)
      this.$set(this.formData1, "address", address)
      this.$set(this.formData, "phone", phone)
      this.$set(this.formData, "familyCall", familyCall)
      this.$set(this.formData1, "portraitImg", portraitImg)
      this.$set(this.formData1, "elderlyBelongCategory", elderlyBelongCategory)
      this.$set(this.formData, "guardian", guardian)
      this.$set(this.formData, "guardianTel", guardianTel)
      this.$set(this.formData, "guardianRelationship", guardianRelationship)
      this.$set(this.formData1, "provinceId", provinceId)
      this.$set(this.formData1, "cityId", cityId)
      this.$set(this.formData1, "areaId", areaId)
      this.$set(this.formData1, "streetId", streetId)
      //  this.$set(this.formData1, "communityId", communityId)

      this.$set(this.formData1, "emergencyContactList", emergencyContactList)
      if (this.formData1.cityId == "null") {
        this.formData1.cityId = ""
      }
      if (this.formData1.areaId == "null") {
        this.formData1.areaId = ""
      }
      if (this.formData1.streetId == "null") {
        this.formData1.streetId = ""
      }
      if (this.formData1.communityId == 0) {
        this.formData1.communityId = ""
      }
      // console.log(this.formData1.latitude,this.formData1.longitude)
      this.potintMap()
      this.$forceUpdate()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      if (val.length > 1) {
        this.$refs.myTable.clearSelection()
        this.$refs.myTable.toggleRowSelection(val.pop())
      }
    },
    handlePrint() {
      this.$print(this.$refs.print)
    },
    async deleteItem(row) {
      const confirm = await this.$confirm(
        "此操作将永久删除该信息, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err)
      if (confirm === "confirm") {
        request({
          url: "ypt/admin/assessment/info/delete",
          method: "POST",
          data: {
            id: row.id,
          },
        }).then((res) => {
          if (res.code == 200) {
            this.showList()
            this.$message({
              message: "删除成功",
              type: "success",
            })
            return
          }
          this.$message({
            message: "删除失败",
            type: "error",
          })
        })
      } else {
        this.$message({
          message: "取消删除",
          type: "info",
        })
      }
    },
    showPerson() {
      if (this.dialogTitle === "查看") {
        this.addVisible = false
        return false
      }
      this.addVisible = true
      this.queryInfo1 = {}
      this.showList1()
    },
    showList1() {
      let params = {
        pageNo: this.query1.pageNo,
        pageSize: this.query1.pageSize,
        intoState: 1,
      }
      this.$http
        .request({
          url: "/ypt/admin/all/customer/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.fromTable = []
              this.total1 = 0
              return
            }
            this.fromTable = res.content.list
            this.total1 = res.content.count
          }
        })
    },
    QuerySearch1() {
      let params = {
        pageNo: 1,
        pageSize: 10,
        intoState: 1,
        name: this.queryInfo1.name,
        // gender:this.addForm.gender,
        phone: this.queryInfo1.phone,
      }
      this.$http
        .request({
          url: "/jgyl/admin/register/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.fromTable = []
              this.total1 = 0
              return
            }
            this.fromTable = res.content.list
            this.total1 = res.content.count
          }
        })
    },
    showList() {
      let params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        customerName: this.searchObj.customerName,
        gender: this.searchObj.gender,
        phone: this.searchObj.phone,
      }
      this.$http
        .request({
          url: "/ypt/admin/assessment/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.total = 0
              return
            }
            this.tableData = res.content.list
            this.total = res.content.count
          }
        })
    },
    // 分页1
    handleSizeChange(val) {
      this.query.pageSize = val
      this.showList()
    },
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.showList()
    },
    handleCurrentChange1(val) {
      this.query.pageNo = val
      this.showList()
    },
    // 分页1
    handleSizeChange1(val) {
      this.query1.pageSize = val
      this.showList1()
    },
    handleCurrentChange1(val) {
      this.query1.pageNo = val
      this.showList1()
    },
    ResetQuery() {},
    // 新增输入框
    addItem() {
      this.formData1.emergencyContactList.push({
        name: "",
        phone: "",
        relationship: "",
      })
    },
    removeItem(index) {
      this.formData1.emergencyContactList.splice(index, 1)
    },
    evaluate(row) {
      this.addDialogVisible = true
      // this.getshowp(row)
      this.$http
        .request({
          url: "/ypt/admin/assessment/info/get",
          method: "POST",
          data: {
            id: row.id,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.queryForm = res.content || {}
            this.queryForm1 = res.content || {}
            return
          }
          this.$message({
            message: "根据ID获取信息失败",
            type: "error",
          })
        })
    },
    // getshowp(row) {
    //     this.$http
    //         .request({
    //             url: "/jgyl/admin/register/info/get",
    //             method: "POST",
    //             data: {
    //                 id: row.registerId,
    //             },
    //         })
    //         .then((res) => {
    //             if (res.code == 200) {
    //                 this.queryForm1 = res.content || {}
    //                 return
    //             }
    //             this.$message({
    //                 message: "根据ID获取信息失败",
    //                 type: "error",
    //             })
    //         })
    // },
    handleClose() {
      this.addVisible = false
    },
    handleClose1() {
      this.addVisible = false
    },
    tableResert() {
      // this.showList()
      let params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
      }
      this.$http
        .request({
          url: "/ypt/admin/assessment/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.total = 0
              return
            }
            this.tableData = res.content.list
            this.total = res.content.count
          }
        })
    },
    //table表格表单弹窗关闭时事件
    dialogVisibleClone() {
      this.addDialogVisible = false
      let ele = document.getElementById("chatRecord")
      ele.scrollTop = 0
    },
    showDialog(title, row) {
      this.getPersonnelTypeList()
      // this.showOldList()
      this.controlAddContent = 1
      this.dialogVisible = true
      this.dialogTitle = title
      let self = this
      setTimeout(async () => {
        await self.$nextTick(() => self.loadMap())
      }, 30)
      this.formData = {
        name: "",
      }
      this.formData1 = {
        idCard: "",
        address: "",
        elderlyBelongCategory: "",
        emergencyContactList: [
          {
            name: "",
            phone: "",
            relationship: "",
          },
        ],
      }
      switch (title) {
        case "新增":
          break
        case "查看":
          break
      }
      if (this.dialogTitle == "查看") {
        // this.getship(row)
        this.$http
          .request({
            url: "/ypt/admin/assessment/info/get",
            method: "POST",
            data: {
              id: row.id,
            },
          })
          .then(async (res) => {
            if (res.code == 200) {
              this.formData = res.content
              this.formData1 = res.content
              this.formData1.elderlyBelongCategory = Number(
                res.content.elderlyBelongCategory
              )
              this.formData1.provinceId = String(res.content.provinceId)
              this.formData1.cityId = String(res.content.cityId)
              this.formData1.areaId = String(res.content.areaId)
              this.formData1.longitude = res.content.longitude
              this.formData1.latitude = res.content.latitude
              this.formData1.streetId = String(res.content.streetId)
              this.formData1.communityId = res.content.communityId
              this.formData1.emergencyContactList =
                res.content.emergencyContactList
              this.formData1.portraitImg = res.content.portraitImg
              this.formData1.hkbHome = res.content.hkbHome
              this.formData1.hkbOneself = res.content.hkbOneself
              this.formData1.idJust = res.content.idJust
              this.formData1.idBack = res.content.idBack
              this.formData1.streetId = String(this.formData1.streetId)
              this.formData1.communityId = Number(this.formData1.communityId)
              if (!this.formData1.provinceId) return
              this.getDistrict(this.formData1.provinceId).then((res) => {
                this.cityList = res.districtList
              })

              if (!this.formData1.cityId) return
              this.areaList = await this.getStreetList(this.formData1.cityId)
              if (!this.formData1.areaId) return
              if (this.formData1.areaId == "null") {
                this.formData1.areaId = ""
              } else {
                let streetList = await this.getStreetList(this.formData1.areaId)
                this.streetList = streetList
              }
              if (!this.formData1.streetId) return
              if (this.formData1.streetId == "null") {
                this.formData1.streetId = ""
              } else {
                let communityList = await this.getStreetList(
                  this.formData1.streetId
                )
                this.communityList = communityList
              }

              if (this.formData1.communityId == 0) {
                this.formData1.communityId = ""
              }
              this.potintMap()
              return
              return
            }
            this.$message({
              message: "根据ID获取信息失败",
              type: "error",
            })
          })
      }
    },
    getship(row) {
      this.$http
        .request({
          url: "/jgyl/admin/register/info/get",
          method: "POST",
          data: {
            id: row.customerId,
            // id: row.id
          },
        })
        .then(async (res) => {
          if (res.code == 200) {
            //  this.formData.name = res.content.name
            this.formData1.idCard = res.content.idCard
            this.formData1.birthday = res.content.birthday
            this.formData1.elderlyBelongCategory =
              res.content.elderlyBelongCategory
            this.formData1.address = res.content.address
          }
          this.$message({
            message: "根据ID获取信息失败",
            type: "error",
          })
        })
    },
    Refresh1() {
      this.queryInfo1.name = ""
      this.queryInfo1.phone = ""
      this.showList1()
    },
    eResert() {
      this.showList()
    },
    tableShow(e) {
      this.choiceList = e.map((item) => item)
    },
    changeIdx(id) {
      this.controlAddContent = id
    },
    // 身份证获取信息
    idCardchange(val) {
      console.log(val)
      // let obj = discriCard(val)
      // console.log(obj)
      //出生年月
      var birthday = ""
      if (val != null && val != "") {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6)
        } else if (val.length == 18) {
          birthday = val.substr(6, 8)
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-")
      }
      this.formData.birth = birthday

      // 年龄
      var myDate = new Date()
      var month = myDate.getMonth() + 1
      var day = myDate.getDate()
      var age = myDate.getFullYear() - val.substring(6, 10) - 1
      if (
        val.substring(10, 12) < month ||
        (val.substring(10, 12) == month && val.substring(12, 14) <= day)
      ) {
        age++
      }
      this.formData.age = age
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2

      // if (!isJPG) {
      // 	this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isLt2M
    },
    beforeAvatarUpload1(file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
      }
      return isLt2M
    },
    getElderlyInfoList() {
      this.showList()
    },
    //  绘制图片（拍照功能）
    setImage() {
      var _this = this
      // 点击，canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      )
      // 获取图片base64链接
      var image = this.thisCancas.toDataURL("image/png")
      const file = this.dataURLtoFile(image, "xxx")
      _this.imgSrc = image
      this.$emit("refreshDataList", this.imgSrc)
      this.stopNavigator()
      this.uploadShow = 1
      const fd = new FormData()
      fd.append("file", file)
      this.$http
        .request({
          url: this.actionUrl,
          method: "POST",
          data: fd,
        })
        .then((res) => {
          if (res.code == 200) {
            this.$set(this.formData, "photo", res.content)
          }
        })

      this.$refs.uploadAvatar.submit()
    },
    // base64转文件
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",")
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, {
        type: mime,
      })
    },
    // 关闭摄像头
    stopNavigator() {
      this.thisVideo.srcObject.getTracks()[0].stop()
    },
    handleAvatarSuccess() {},
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.myMap = new AMap.Map("container", {
          resizeEnable: true,
          zoom: 8,
        })
        resolve()
      })
    },
    getMap(input) {
      const self = this
      const autoOptions = {
        city: this.formData1.areaId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.formData1.address = e.poi.name
        self.formData1.longitude = e.poi.location.lng
        self.formData1.latitude = e.poi.location.lat
        console.log(e.poi.location, "地址")
        self.potintMap()
      })
    },
    // 打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(self.formData1.longitude),
          Number(self.formData1.latitude),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    // 五级联动地图方法
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData1.cityId = ""
      this.formData1.areaId = ""
      this.formData1.streetId = ""
      this.formData1.communityId = ""
      this.formData1.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    async getProvince() {
      this.provinceLis = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.formData1.areaId = ""
      this.formData1.streetId = ""
      this.formData1.communityId = ""
      this.formData1.address = ""
      let area = await this.getStreetList(val)
      this.areaList = area
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.formData1.streetId = ""
      this.formData1.communityId = ""
      this.formData1.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getStreetList(val)
      this.streetList = street
      this.joinAddress()
    },
    //街道地址发生变化
    async streetChange(val, flag = null) {
      this.formData1.communityId = ""
      let communityList = await this.getStreetList(val)
      this.communityList = communityList
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              // this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      if (val != "null") {
        let self = this
        return new Promise((resolve, reject) => {
          self.$http
            .request({
              url: "/ypt/admin/standardAddress/info/StandardAddressTree",
              method: "POST",
              data: {
                streetId: val,
              },
            })
            .then((res) => {
              if (res.code == 200) {
                if (!res.content) {
                  resolve([])
                  return
                }
                this.shequList = res.content
                resolve(res.content)
              } else {
                resolve([])
              }
            })
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    //社区地址发生变化
    handleCommunityChange() {
      this.joinAddress()
    },
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {}

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {})
    },
    // showOldList() {
    //     let params = {
    //         pageNo: 1,
    //         pageSize: 1000,
    //         type: "4",
    //         state: "1",
    //     }
    //     this.$http
    //         .request({
    //             url: "/jgyl/admin/serviceName/info/findList",
    //             method: "POST",
    //             data: params,
    //         })
    //         .then((res) => {
    //             if (res.code == 200) {
    //                 if (res.content == null || res.content == "null") {
    //                     this.oldList = []
    //                     return
    //                 }
    //                 this.oldList = res.content.list
    //             }
    //         })
    // },
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel
        if (!address) {
          self.formData.address =
            shengName + shiName + quName + jiedaoName + shequName
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({
          city: "",
        })
        self.marker = new AMap.Marker()
        geocoder.getLocation(this.formData1.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.formData1.addressLng = lnglat.lng
            self.formData1.addressLat = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    //人员类型
    getPersonnelTypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "customer.type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.personnelTypeList = res.rows
            }
          }
        })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
  border-bottom: 1px solid #ccc;
}

.btn_group {
  margin: 20px 0;
}

.operation-btn > span {
  display: inline-block;
  width: 30%;
  text-align: center;
  cursor: pointer;
}

.operation-color:hover {
  color: #00aaff;
}

.bottom-page {
  margin: 20px 0;
}

.addBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.uploadAvatar {
  margin-left: 90px;
}

.name-per {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 20px;
}

.name-list {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.changeColor > div:first-child {
  background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
  color: #0000ff;
}

.changeColor > div:last-child {
  background-color: #0000ff;
}

.name-bottom {
  text-align: center;
}

.elder_manage_title {
  position: relative;
  width: 100%;
  margin-bottom: 15px;

  &::after {
    position: absolute;
    left: 120px;
    right: 0;
    display: block;
    content: "";
    border-bottom: 1px solid #e4e7ed;
  }

  .title {
    box-sizing: border-box;
    display: inline-block;
    width: 120px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #409eff;
    font-size: 14px;
    border: 1px solid #e4e7ed;
    border-bottom: none;
    border-radius: 4px 4px 0 0;
    box-sizing: border-box;
    background: #ffffff;
  }
}

.search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f1f2f6;
  box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
  overflow: hidden;
  border-radius: 4px;

  .search_head {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }

  .search_content {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    // display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .search_inline {
    width: 100%;
  }

  .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
}

.searchDomw {
  cursor: pointer;
}

/deep/ .avatar-uploader1 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader1 .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

/deep/ .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #ccc;
}

.btn_group {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}

/deep/ .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

/deep/ .avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.name-per {
  width: 90%;
  margin: 0 auto;
  display: flex;
  margin-bottom: 20px;
}

.name-list {
  width: 50%;
  cursor: pointer;
  display: flex;
  justify-content: center;
}

.name-list > div:first-child {
  width: 100%;
}

.name-title {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.name-title > div:first-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.name-title > div:last-child {
  width: 50%;
  height: 2px;
  background-color: #eeeeee;
}

.changeColor > div:first-child {
  background-color: #0000ff;
}

.changeColor > div:nth-child(2) {
  color: #0000ff;
}

.changeColor > div:last-child {
  background-color: #0000ff;
}

.name-bottom {
  text-align: center;
}

.addBox {
  display: flex;
  width: 100%;
  justify-content: flex-start;
}

.uploadAvatar {
  margin-left: 90px;
}

.print_container {
  .print_title {
    text-align: center;
    font-size: 24px;
    font-weight: bold;
  }

  .address_wrap {
    display: flex;
    justify-content: center;

    .item {
      position: relative;
      padding-left: 120px;
      margin-top: 24px;
      margin-bottom: 24px;

      & + .item {
        margin-left: 60px;
      }

      span {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 120px;
        border-bottom: 1px solid #000000;
        text-align: center;
      }
    }
  }

  .user_info {
    &:nth-child(4) {
      .inline_wrap {
        padding-bottom: 0;
        padding-top: 0;
      }
    }

    &:nth-child(6) {
      .content {
        padding-bottom: 0;
        padding-top: 0;
      }
    }

    .price_wrap {
      position: relative;
      padding-left: 120px;
      display: inline-block;

      span {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 120px;
        border-bottom: 1px solid #000000;
      }
    }

    .label {
      width: 120px;
    }

    .inline_title {
      text-align: left;
      text-indent: 12px;

      /deep/ .el-checkbox {
        margin-right: 0;
        text-indent: 0;
      }
    }

    .sign {
      padding: 12px;
      text-align: left;
    }

    .sign_ont {
      padding: 12px;
      text-align: left;
      padding-bottom: 60px;
    }

    .date {
      padding: 12px;
      text-align: right;

      span {
        margin-left: 30px;
      }
    }

    /deep/ .inline_wrap_box {
      display: flex;
      flex-wrap: wrap;
      padding: 12px;
      text-align: left;
      border-bottom: 1px solid #000000;
      margin-bottom: 22px;

      .inline_wrapper {
        width: calc(100% / 3);
        box-sizing: border-box;
      }

      .inline_label {
        margin-right: 12px;
        width: 80px;
        display: inline-block;
      }

      .el-checkbox-group {
        display: inline-block;
      }

      .el-checkbox {
        margin-bottom: 8px;
      }
    }

    /deep/ .inline_wrap {
      padding: 12px;
      text-align: left;

      .inline_label {
        margin-right: 12px;
      }

      .el-checkbox-group {
        display: inline-block;
      }

      .el-checkbox {
        margin-bottom: 8px;
      }
    }

    .inline_tips {
      line-height: 1.2;
      text-align: left;
      padding: 0 12px;
    }

    .inline_table {
      width: 100%;
      height: 100%;
      text-align: center;
      border-collapse: collapse;

      tr:first-child {
        td {
          border-top: none;
        }
      }

      tr:last-child {
        td {
          border-bottom: none;
        }
      }

      tr td {
        &:nth-child(1) {
          border-left: none;
        }

        &:last-child {
          border-right: none;
        }
      }

      .reform_wrap {
        padding: 0;

        p {
          margin-bottom: 4px;
        }

        .reform_content_c {
          display: flex;

          span {
            flex: 1;
            text-align: center;
            padding: 0 3px;
          }
        }

        .reform_content {
          display: flex;
          padding-top: 12px;
          border-top: 1px solid #000000;

          span {
            flex: 1;
            text-align: center;
            padding: 0 3px;
          }
        }
      }
    }
  }

  .table_container,
  table tr th,
  table tr td {
    border: 1px solid #000000;
  }

  .table_container {
    width: 100%;
    text-align: center;
    border-collapse: collapse;

    .inner-tr {
      &:first-child td {
        border-top: none;
      }

      &:last-child td {
        border-bottom: none;
      }

      td:nth-child(1) {
        border-left: none;
        border-right: none;
        border-bottom: none;
      }

      td:last-child {
        border-right: none;
        border-bottom: none;
      }
    }
  }
}

.authorization {
  margin-left: 26%;

  p {
    margin: 20px 0;
    font-size: 18px;
  }
}

.dialog-footer {
  width: 100%;
  display: flex;
  justify-content: center;
}

.btnSite {
  display: flex;
  justify-content: center;
}
</style>
